"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSDK = exports.createSDK = void 0;
var _IssuesApi = require("./api/IssuesApi");
var _IssueCommentsApi = require("./api/IssueCommentsApi");
var _IssueViewersApi = require("./api/IssueViewersApi");
var _IssueTypesApi = require("./api/IssueTypesApi");
var _IssueRootCausesApi = require("./api/IssueRootCausesApi");
var _CurrentUserPermissionsApi = require("./api/CurrentUserPermissionsApi");
var _IssueCustomAttributesApi = require("./api/IssueCustomAttributesApi");
var _IssuePermissionsApi = require("./api/IssuePermissionsApi");
var _IssueLinksApi = require("./api/IssueLinksApi");
var _IssueActivityLogApi = require("./api/IssueActivityLogApi");
var _IssueTemplatesApi = require("./api/IssueTemplatesApi");
var _IssueStatusesAPI = require("./api/IssueStatusesAPI");
var _IssueMarkupsApi = require("./api/IssueMarkupsApi");
var _IssuesBcfApi = require("./api/IssuesBcfApi");
var _IssueSnapshotsApi = require("./api/IssueSnapshotsApi");
var _RelationshipsApi = require("./api/RelationshipsApi");
var _IssuePlacementsApi = require("./api/IssuePlacementsApi");
var _IssueAttachmentsApi = require("./api/IssueAttachmentsApi");
var _OssApi = require("./api/OssApi");
var _BcfApi = require("./api/BcfApi");
const createSDK = config => {
  return {
    projectId: config.projectId,
    Issues: (0, _IssuesApi.IssuesApi)(config),
    IssueComments: (0, _IssueCommentsApi.IssueCommentsApi)(config),
    IssueViewers: (0, _IssueViewersApi.IssueViewersApi)(config),
    IssueTypes: (0, _IssueTypesApi.IssueTypesApi)(config),
    IssueRootCauses: (0, _IssueRootCausesApi.IssueRootCausesApi)(config),
    IssueCustomFields: (0, _IssueCustomAttributesApi.IssueCustomAttributesApi)(config),
    CurrentUserPermissions: (0, _CurrentUserPermissionsApi.CurrentUserPermissionsApi)(config),
    IssuePermissions: (0, _IssuePermissionsApi.IssuePermissionsApi)(config),
    IssueLinks: (0, _IssueLinksApi.IssueLinksApi)(config),
    IssueActivityLogApi: (0, _IssueActivityLogApi.IssueActivityLogApi)(config),
    IssueTemplates: (0, _IssueTemplatesApi.IssueTemplatesApi)(config),
    IssueStatuses: (0, _IssueStatusesAPI.IssueStatusesAPI)(config),
    IssueMarkups: (0, _IssueMarkupsApi.createIssueMarkupsApi)({
      ...config,
      headers: _IssueMarkupsApi.headers
    }),
    IssuesBcf: (0, _IssuesBcfApi.IssuesBcfApi)(config),
    IssueSnapshots: (0, _IssueSnapshotsApi.IssueSnapshotsApi)(config),
    IssuePlacements: (0, _IssuePlacementsApi.IssuePlacementsApi)(config),
    //IssuePins: IssuePinsApi(config), //TODO uncomment when intended to make it public
    IssueAttachments: (0, _IssueAttachmentsApi.IssueAttachmentsApi)(config),
    Relationships: (0, _RelationshipsApi.RelationshipsApi)(config),
    Oss: (0, _OssApi.OssApi)({
      ...config,
      headers: _OssApi.headers
    }),
    Bcf: (0, _BcfApi.createBcfApi)({
      ...config,
      headers: _BcfApi.headers
    })
  };
};

/**
 * This function provides a unified way to update the `IssuesSDKConfig` for every endpoint sdk without
 * re-creating the `IssuesSDK` object. The `IssuesSDK` object is used as a singleton, so deleting and
 * re-instantiating it can produce unwanted side effects. The `IssuesSDKConfig` object allows us to
 * share context-specific data with every endpoint handler.
 *
 * The use case that inspired to implement this function was to add headers to every request that we send
 * to the issues api based on the value of a feature flag.
 */
exports.createSDK = createSDK;
const updateSDK = (sdk, config) => {
  sdk.projectId = config.projectId;
  sdk.Issues = (0, _IssuesApi.IssuesApi)(config);
  sdk.IssueComments = (0, _IssueCommentsApi.IssueCommentsApi)(config);
  sdk.IssueViewers = (0, _IssueViewersApi.IssueViewersApi)(config);
  sdk.IssueTypes = (0, _IssueTypesApi.IssueTypesApi)(config);
  sdk.IssueRootCauses = (0, _IssueRootCausesApi.IssueRootCausesApi)(config);
  sdk.IssueCustomFields = (0, _IssueCustomAttributesApi.IssueCustomAttributesApi)(config);
  sdk.CurrentUserPermissions = (0, _CurrentUserPermissionsApi.CurrentUserPermissionsApi)(config);
  sdk.IssuePermissions = (0, _IssuePermissionsApi.IssuePermissionsApi)(config);
  sdk.IssueLinks = (0, _IssueLinksApi.IssueLinksApi)(config);
  sdk.IssueActivityLogApi = (0, _IssueActivityLogApi.IssueActivityLogApi)(config);
  sdk.IssueTemplates = (0, _IssueTemplatesApi.IssueTemplatesApi)(config);
  sdk.IssueStatuses = (0, _IssueStatusesAPI.IssueStatusesAPI)(config);
  sdk.IssueMarkups = (0, _IssueMarkupsApi.createIssueMarkupsApi)({
    ...config,
    headers: _IssueMarkupsApi.headers
  });
  sdk.IssuesBcf = (0, _IssuesBcfApi.IssuesBcfApi)(config);
  sdk.IssueSnapshots = (0, _IssueSnapshotsApi.IssueSnapshotsApi)(config);
  sdk.IssuePlacements = (0, _IssuePlacementsApi.IssuePlacementsApi)(config);
  //sdk.IssuePins = IssuePinsApi(config); //TODO uncomment when intended to make it public
  sdk.IssueAttachments = (0, _IssueAttachmentsApi.IssueAttachmentsApi)(config);
  sdk.Bcf = (0, _BcfApi.createBcfApi)({
    ...config,
    headers: _IssueMarkupsApi.headers
  });
};
exports.updateSDK = updateSDK;
//# sourceMappingURL=createSdk.js.map